/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Honest_Flat_Finch_DineInputs */

const fr_honest_flat_finch_dine = /** @type {(inputs: Honest_Flat_Finch_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu de la section`)
};

/**

* @param {Honest_Flat_Finch_DineInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const honest_flat_finch_dine = /** @type {((inputs?: Honest_Flat_Finch_DineInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Honest_Flat_Finch_DineInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_honest_flat_finch_dine(inputs)
});